"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const styled_1 = require("./styled");
const ChevronLeftSolid_1 = __importDefault(require("../../../IconsNavigation/ChevronLeftSolid"));
const animationDuration = 500;
const SlideDrawer = ({ children, show, title, closeFn, hideClose, }) => {
    const nodeRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_transition_group_1.CSSTransition, { nodeRef: nodeRef, in: show, timeout: animationDuration, unmountOnExit: true, mountOnEnter: true }, (state) => (react_1.default.createElement(styled_1.Wrapper, { ref: nodeRef, state: state, duration: animationDuration },
            react_1.default.createElement(styled_1.Content, null,
                react_1.default.createElement(styled_1.TitleWrapper, null,
                    !hideClose && (react_1.default.createElement(styled_1.CloseButton, { onClick: closeFn },
                        react_1.default.createElement(ChevronLeftSolid_1.default, { size: 16, color: "#0085FF" }))),
                    react_1.default.createElement(styled_1.TitleText, null, title)),
                react_1.default.createElement(styled_1.ChildrenWrapper, null, children)))))));
};
exports.default = SlideDrawer;
//# sourceMappingURL=SlideDrawer.js.map